import React, { useRef } from 'react'

import { PERFORMANCE_TOOLTIP } from 'utils/testing/testIDs'

import { currencyFormatterNoTrailingZeros } from '../../helpers'
import { getTooltipOffsetX } from './helpers'
import {
  ArrowDown,
  Divider,
  Tooltip,
  TooltipAccountValue,
  TooltipContent,
  TooltipDate,
  TooltipWrapper,
} from './styled-components'

export const TooltipOverlay = ({
  date,
  elWidth: containerWidth,
  isActive,
  offsetX,
  accountValue,
}: {
  accountValue: number
  date: string
  elWidth: number
  isActive: boolean
  offsetX: number
}): React.ReactElement => {
  const tooltipRef = useRef<HTMLDivElement>(null)

  let tooltipWidth = 0
  if (tooltipRef) {
    tooltipWidth = tooltipRef.current?.clientWidth || 0
  }

  const tooltipOffsetX = getTooltipOffsetX({
    offsetX,
    containerWidth,
    tooltipWidth,
  })

  return (
    <TooltipWrapper data-testid={PERFORMANCE_TOOLTIP} isActive={isActive}>
      <Divider offsetX={offsetX} />
      <ArrowDown offsetX={offsetX} />
      <Tooltip ref={tooltipRef} offsetX={tooltipOffsetX}>
        <TooltipContent>
          <TooltipAccountValue>
            {currencyFormatterNoTrailingZeros(accountValue)}
          </TooltipAccountValue>
          <TooltipDate>{date}</TooltipDate>
        </TooltipContent>
      </Tooltip>
    </TooltipWrapper>
  )
}
